import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "w-[400px] h-[400px] rounded-xl shadow-lg p-8 flex flex-col items-center justify-center transform transition-all hover:shadow-xl gap-6 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-100" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Logo",
        class: "w-24 h-24 mb-2"
      }),
      _createElementVNode("h1", { class: "text-4xl font-bold text-center bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent" }, " Welcome Developers ")
    ], -1)
  ])))
}